import React from "react";
import GalleryContainer from "../containers/gallery-container";

const GalleryPage = () => (
  <main className="gallery-page">
    <GalleryContainer />
  </main>
);

export default GalleryPage;
